
export const FETCH_WAITERS_REQUEST = "FETCH_WAITERS_REQUEST";
export const FETCH_WAITERS_SUCCESS = "FETCH_WAITERS_SUCCESS";
export const FETCH_WAITERS_FAILURE = "FETCH_WAITERS_FAILURE";

export const CREATE_WAITER_REQUEST = "CREATE_WAITER_REQUEST";
export const CREATE_WAITER_SUCCESS = "CREATE_WAITER_SUCCESS";
export const CREATE_WAITER_FAILURE = "CREATE_WAITER_FAILURE";

export const UPDATE_WAITER_REQUEST = "UPDATE_WAITER_REQUEST";
export const UPDATE_WAITER_SUCCESS = "UPDATE_WAITER_SUCCESS";
export const UPDATE_WAITER_FAILURE = "UPDATE_WAITER_FAILURE";

export const DELETE_WAITER_REQUEST = "DELETE_WAITER_REQUEST";
export const DELETE_WAITER_SUCCESS = "DELETE_WAITER_SUCCESS";
export const DELETE_WAITER_FAILURE = "DELETE_WAITER_FAILURE";
